import React from "react";
import 'react-quill/dist/quill.snow.css';

interface TextQuoteSection {
    id: number;
    quote?: string;
    bodyCopy?: string;
}

interface TextQuoteProps {
    section: TextQuoteSection;
    onChange: (id: number, updatedData: Partial<TextQuoteSection>) => void;
    onClose: () => void;
}

const TextQuote: React.FC<TextQuoteProps> = ({ section, onChange, onClose }) => {
    const ReactQuill = require('react-quill');

    const quillModules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ align: [] }],
            ['link'],
            ['clean'],
        ],
    };

    const handleQuoteChange = (value: string) => onChange(section.id, { quote: value });
    const handleBodyChange = (value: string) => onChange(section.id, { bodyCopy: value });

    return (
        <div style={{
            padding: '10px',
            marginBottom: '20px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        }}>
            {/* Close button */}
            <button
                style={{
                    position: 'absolute',
                    top: 5,
                    right: 5,
                    border: 'none',
                    background: 'none',
                    color: 'black',
                    cursor: 'pointer'
                }}
                onClick={onClose}
            >
                X
            </button>

            {/* Editors container */}
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '10px',
                flexWrap: 'wrap',
                alignItems: 'flex-start',
                width: '100%',
                marginTop: '10px',
            }}>
                {/* Body editor */}
                <div style={{
                    flex: 1,
                    minWidth: 250, // ensures it shrinks on smaller screens
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <label>Body Content</label>
                    <ReactQuill
                        value={section.bodyCopy || ''}
                        onChange={handleBodyChange}
                        modules={quillModules}
                        theme="snow"
                        style={{ width: '100%', height: 'auto', boxSizing: 'border-box' }}
                    />
                </div>

                {/* Quote editor */}
                <div style={{
                    flex: 1,
                    minWidth: 250,
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <label>Quote</label>
                    <ReactQuill
                        value={section.quote || ''}
                        onChange={handleQuoteChange}
                        modules={quillModules}
                        theme="snow"
                        style={{ width: '100%', height: 'auto', boxSizing: 'border-box' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default TextQuote;
